/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AuthActions, AuthActionTypes, AuthState } from './types';

const initialForm = { email: '', firstName: '', lastName: '' };

export const initialAuthState: AuthState = {
  isFetching: true,
  isRefreshing: true,
  user: undefined,
  isAuthenticated: false,
  isAuthCheckCompleted: false,
  errorMessage: undefined,

  form: { ...initialForm },
};

export function auth(state = initialAuthState, action: AuthActionTypes): AuthState {
  switch (action.type) {
    case AuthActions.AUTHORIZE_USER_BY_TOKEN_WATCHER:
      return {
        ...state,
        isFetching: true,
      };
    case AuthActions.AUTH_CHECK_START:
      return {
        ...state,
        isFetching: true,
        isRefreshing: false,
        isAuthenticated: false,
        user: undefined,
        isAuthCheckCompleted: false,
        errorMessage: undefined,
      };
    case AuthActions.AUTH_CHECK_AUTHORIZED:
      return {
        ...state,
        isFetching: false,
        isRefreshing: false,
        isAuthenticated: true,
        user: action.payload.user,
        isAuthCheckCompleted: true,
      };
    case AuthActions.AUTH_CHECK_NOT_AUTHORIZED:
      return {
        ...state,
        isFetching: false,
        isRefreshing: false,
        isAuthenticated: false,
        isAuthCheckCompleted: true,
        user: undefined,
      };
    case AuthActions.AUTH_SET_USER:
      return {
        ...state,
        isFetching: false,
        isRefreshing: false,
        isAuthenticated: true,
        user: action.payload.user,
        isAuthCheckCompleted: true,
      };
    case AuthActions.AUTH_LOGOUT:
      return {
        ...state,
        isFetching: false,
        isRefreshing: false,
        isAuthenticated: false,
        user: undefined,
        isAuthCheckCompleted: true,
        errorMessage: undefined,
      };
    case AuthActions.AUTH_CLEANER:
      return {
        ...state,
        isFetching: false,
        isRefreshing: false,
        errorMessage: undefined,
        form: { ...initialForm },
      };
    case AuthActions.AUTH_REFRESH_START:
      return {
        ...state,
        isRefreshing: true,
      };
    case AuthActions.AUTH_REFRESH_COMPLETED:
      return {
        ...state,
        isRefreshing: false,
      };
    default:
      return state;
  }
}
